module.exports = "/dashboard/manage/users/components/editSalariesComponent-b4905f.html";